import React from "react";
import PropTypes from "prop-types";
import { InputItem } from "..//forms/FormItems";
import AddEntityForm from "../../components/templates/AddEntityForm";

const NewColumn = (props) => {
  const { hide, addText, onAddColumn, loading, comp, compName } = props;

  const onFinish = async (values) => {
    onAddColumn(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const onDecline = () => {
    hide();
  };

  const items = [
    {
      name: compName,
      required: true,
      comp,
    },
    {
      name: "display_name",
      required: true,
      comp: (
        <InputItem
          name="display_name"
          category="columnsSettings"
          required={true}
        />
      ),
    },
  ];

  return (
    <AddEntityForm
      resource="users"
      action="editor"
      items={items}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      onDecline={onDecline}
      saveLoading={loading}
      addText={addText}
    />
  );
};

NewColumn.propTypes = {
  hide: PropTypes.func,
  addText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default NewColumn;
